import {Observable} from 'rxjs'
import {Actions, createEffect, CreateEffectMetadata, ofType} from '@ngrx/effects'
import {NotAllowedCheck} from '@ngrx/store'
import {TypedAction} from '@ngrx/store/src/models'
import {tap} from 'rxjs/operators'
import {Injectable} from '@angular/core'
import {NavigationService} from '../services/navigation/navigation.service';

export declare type SimpleRedirectEffectType<T> = Observable<T> & CreateEffectMetadata
export declare type ActionType<T extends object> = ((props: (T & NotAllowedCheck<T>)) => (T & TypedAction<string>)) & TypedAction<string>

@Injectable({providedIn: 'root'})
export class EffectUtil {

  constructor(private actions$: Actions, private navigationService: NavigationService) {
  }

  createRedirectEffect<T extends object>(action: ActionType<T>, url: string): SimpleRedirectEffectType<T> {
    return createEffect(() => this.actions$.pipe(
      ofType(action),
      tap(() => this.navigationService.navigate([url]))
      ), {dispatch: false}
    )
  }

}
